<template>
  <div class="d-flex">
    <b-form-input type="text"
        :placeholder="placeholder"
        v-model="localValue"
        :maxlength="maxlength"
        :required="required"
        :state="state"
        v-mask="['##:##']">
    </b-form-input>
    <b-form-timepicker
        ref="formTimePicker"
        button-only
        button-variant="addon-square"
        right
        locale="pt-BR"
        aria-controls="HorarioEnvio"
        @context="onContext"
    >
      <template #button-content>
        <i class="fas fa-clock"></i>
      </template>
    </b-form-timepicker>
  </div>
</template>

<script>
export default {
  name: 'NxTimePicker',
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: 'HH:MM'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Boolean | null,
      required: false,
      default: null
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  data () {
    return {
      localValue: null,
      selectedValue: null
    }
  },
  watch: {
    localValue (newValue) {
      if (newValue !== this.value) {
        this.$emit('update:value', newValue)
      }
    },
    value (newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onContext (ctx) {
      let value = ctx.value && ctx.formatted

      if (value && this.localValue !== value) {
        this.localValue = value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/NxTimePicker.vue